/**
 * PK 开场动画
 */

import React from 'react';
import styled from 'styled-components';
import SvgaPlayer from '@/modules/party/ui/svga';

const PkSvga = () => {
  return (
    <Wrap>
      <SvgaPlayer url="https://test-img.sumeme.com/swf/flight-pk-start19412.svga" />
    </Wrap>
  );
};

const Wrap = styled.div`
  position: absolute;
  width: 346px;
  height: 346px;
  top: -460px;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;

  ._dark & {
    z-index: 2;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .svga-player {
    width: 100%;
    height: 100%;
  }
`;

export default PkSvga;
